/** @format */

import {SaveSpaces, SpaceId, SpaceList} from 'pages/Home/DigitalCast/models/spaces';

interface Options extends SaveSpaces {
  originalSpace: SpaceList | null;
  spaceId: SpaceId;
}

const removeSpace = ({originalSpace, spaceId, saveSpacesSettings}: Options): SpaceList | null => {
  if (!originalSpace) {
    return null;
  }
  const spaceIds = Object.keys(originalSpace) as SpaceId[];
  const result: SpaceList = {};

  spaceIds.forEach(id => {
    if (id !== spaceId) {
      result[id] = originalSpace[id];
    }
  });

  saveSpacesSettings(result);

  return result;
};

export default removeSpace;
